/**
 * Default Click Tracking Utilities
 *
 * Builds the generic click tracking string (position|description|linkType) used by
 * standalone Homepage components (Postcard, Carousel, PostcardContainer) that are
 * not part of the DynamicTabbedLayout (DTL) slot pipeline.
 *
 * - position -> eVar164 (PAGE LOCATION)
 * - description -> eVar165 (LINK DESCRIPTION)
 */

import { Types } from '@marriott/mi-ui-library';
import type { TrackingPropsInterface } from '@marriott/mi-ui-library';
import { isExternalUrl } from './url-utils';

export type ClickTrackingProps = {
  fallbacks: {
    position: string;
    description: string;
  };
  url?: string | null;
  trackingProperties?: TrackingPropsInterface;
};

export const getClickTrackValue = (
  { fallbacks, url, trackingProperties }: ClickTrackingProps,

  /* TODO: remove this. this is temporary to achieve parity with prod values. eventually we should use actual
    position (e.g. GlobalNav, Footer) and description (e.g. Help, Careers, Privacy Policy) */
  labelOverride?: string
) => {
  const { INTERNAL, EXTERNAL } = Types.LinkTargetType;
  return [
    labelOverride || trackingProperties?.trackingContentPosition || fallbacks.position,
    labelOverride || trackingProperties?.trackingDescription || fallbacks.description,
    isExternalUrl(url) ? EXTERNAL : INTERNAL,
  ].join('|');
};
